import IMisMatchAddressChoice from '@/models/local-storage/IMisMatchAddressChoice';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';

export default {
    hasMisMatchAddress(address1AndUnitNo: string): boolean {
        return theLocalStorageUtils.hasKey(address1AndUnitNo);
    },

    /**
     * Get any existing mismatch address choice by the given address1AndUnitNo
     * @param address1AndUnitNo
     * @returns the mismatch address or null if one doesn't exist
     */
    getMisMatchAddress(address1AndUnitNo: string): IMisMatchAddressChoice | null {
        if (this.hasMisMatchAddress(address1AndUnitNo)) {
            const misMatchAddress = theLocalStorageUtils.get(address1AndUnitNo) as unknown as IMisMatchAddressChoice;
            return misMatchAddress;
        }
        return null;
    },

    /**
     * Add or update a mismatch address choice by the given address1AndUnitNo and mismatchAddress.
     * @param address1AndUnitNo
     * @param misMatchAddress
     */
    saveMisMatchAddress(address1AndUnitNo: string, misMatchAddress: IMisMatchAddressChoice) {
        theLocalStorageUtils.save(address1AndUnitNo, JSON.stringify(misMatchAddress));
    },

    removeMisMatchAddress(address1AndUnitNo: string) {
        theLocalStorageUtils.remove(address1AndUnitNo);
    },
};
